import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/CadastrarModelo.css';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import CardNotification from '../components/CardNotification';
import { useParams, useNavigate } from 'react-router-dom';
import LegendaText from '../components/LegendaText';

import { EditorState, ContentState, convertToRaw, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const EditarModelo = () => {
    const navigate = useNavigate();
    const { id_modelo } = useParams();
    const [nomeModelo, setNomeModelo] = useState('');
    const [imagem, setImagem] = useState(null);
    const [imagemAtual, setImagemAtual] = useState('');
    const [notification, setNotification] = useState({ message: '', type: '', show: false });
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const changeFontSize = (size) => {
        const newEditorState = RichUtils.toggleInlineStyle(editorState, `fontsize-${size}`);
        setEditorState(newEditorState);
    };

    // 🔄 Busca os dados do modelo e converte o texto HTML para EditorState
    const fetchModelo = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/modelo/${id_modelo}`,{
                withCredentials: true
            });
            setNomeModelo(response.data.nome_modelo);
            setImagemAtual(`${process.env.REACT_APP_API_URL1}/${response.data.modelo_foto}`);

            // 📝 Converte o HTML salvo para EditorState
            const htmlContent = response.data.texto;
            const contentBlock = htmlToDraft(htmlContent);
            if (contentBlock) {
                const { contentBlocks, entityMap } = contentBlock;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                setEditorState(EditorState.createWithContent(contentState));
            }
        } catch (error) {
            console.error('Erro ao buscar modelo:', error);
            alert('Erro ao carregar os dados do modelo.');
        }
    };

    useEffect(() => {
        fetchModelo();
    }, [id_modelo]);

    const handleImagemUpload = (event) => {
        const file = event.target.files[0];
        if (file) setImagem(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            const contentState = editorState.getCurrentContent();
            const htmlContent = draftToHtml(convertToRaw(contentState)); // 🔄 Converte para HTML
    
            if (!htmlContent || htmlContent.trim() === "<p></p>") {
                alert('Por favor, insira um texto válido!');
                return;
            }
    
    
            const formData = new FormData();
            formData.append('nome_modelo', nomeModelo);
            if (imagem) formData.append('modelo_foto', imagem); // Adiciona imagem apenas se houver
            formData.append('texto', htmlContent);
    
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/modelo/${id_modelo}?_method=PUT`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true,
                
            });
    
            setNotification({
                message: `Modelo ${response.data.nome_modelo} atualizado com sucesso!`,
                type: 'success',
                show: true,
            });
    
        } catch (error) {
            console.error('Erro ao cadastrar ou atualizar modelo:', error);
            setNotification({
                message: 'Erro ao processar a solicitação. Tente novamente.',
                type: 'error',
                show: true,
            });
        }
    };
    

    const closeNotification = () => setNotification({ ...notification, show: false });

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="cadastrar-modelo-container">
                <div className="voltar-container" onClick={() => navigate('/list-modelo')}>
                    &#8592; <span>Voltar para Modelos</span>
                </div>

                <h1>Editar Modelo de Certificado</h1>
                {notification.show && (
                    <CardNotification message={notification.message} type={notification.type} onClose={closeNotification} />
                )}
                <form onSubmit={handleSubmit} className="cadastrar-modelo-form">
                    <label className="cadastrar-modelo-label">Nome do Modelo:</label>
                    <input
                        type="text"
                        value={nomeModelo}
                        onChange={(e) => setNomeModelo(e.target.value)}
                        className="cadastrar-modelo-input"
                        placeholder="Digite o nome do modelo"
                        required
                    />

                    <label className="cadastrar-modelo-label">Texto do Modelo:</label>
                    <div className="cadastrar-modelo-texto-legenda">
                        {/* 📝 Editor substituindo o textarea */}
                        <Editor
                            editorState={editorState}
                            onEditorStateChange={setEditorState}
                            wrapperClassName="wrapper-class"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                            placeholder="Digite o texto do modelo. Ex: Certificamos que ${nome} concluiu o curso de ${curso}."
                            toolbar={{
                                options: ["inline", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "emoji", "history"],
                                inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                                fontSize: { options: [8, 10, 12, 14, 16, 18, 24, 30, 36, 48, 60] }, // Adiciona tamanhos de fonte
                            }}
                        />
                        <LegendaText />
                    </div>

                    <label className="cadastrar-modelo-label">Upload do Background (opcional):</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImagemUpload}
                        className="cadastrar-modelo-input"
                    />

                    <div className="cadastrar-modelo-preview-container">
                        {imagem ? (
                            <img src={URL.createObjectURL(imagem)} alt="Pré-visualização" className="cadastrar-modelo-preview" />
                        ) : imagemAtual ? (
                            <img src={imagemAtual} alt="Imagem Atual" className="cadastrar-modelo-preview" />
                        ) : (
                            <div className="cadastrar-modelo-preview-simulado">
                                <span>Pré-visualização da imagem</span>
                            </div>
                        )}
                    </div>

                    <button type="submit" className="cadastrar-modelo-button">Salvar Alterações</button>
                </form>
            </div>
        </div>
    );
};

export default EditarModelo;
